import { FunctionComponent, ReactNode } from 'react'
import { Gradient } from 'types'
import { Icon } from 'ui'
import CaptionsEditor from '../editor/captions'
import CropEditor from '../editor/crop'
import DefaultEditor from '../editor/default'
import FiltersEditor from '../editor/filters'
import LayersEditor from '../editor/layers'
import StickersEditor from '../editor/stickers'

export const ugeEditors = ['default', 'captions', 'stickers', 'filters', 'crop', 'layers'] as const

type UgeEditor = typeof ugeEditors[number]

export type UgeEditorProps = {
    children?: ReactNode
}

export function editorComponent(editor: UgeEditor): FunctionComponent<UgeEditorProps> {
    switch (editor) {
        case 'captions':
            return CaptionsEditor
        case 'crop':
            return CropEditor
        case 'default':
            return DefaultEditor
        case 'filters':
            return FiltersEditor
        case 'layers':
            return LayersEditor
        case 'stickers':
            return StickersEditor
    }
}

export function editorGradient(editor: UgeEditor): Gradient {
    switch (editor) {
        case 'captions':
            return 'red-pink'
        case 'crop':
            return 'indigo-cyan'
        case 'default':
            return 'indigo-purple'
        case 'filters':
            return 'indigo-purple'
        case 'layers':
            return 'red-yellow'
        case 'stickers':
            return 'blue-green'
    }
}

export function editorIcon(editor: UgeEditor): Icon {
    switch (editor) {
        case 'captions':
            return 'caption'
        case 'crop':
            return 'crop'
        case 'default':
            return 'edit'
        case 'filters':
            return 'filter'
        case 'layers':
            return 'layers'
        case 'stickers':
            return 'sticker-outline'
    }
}

export function editorTitle(editor: UgeEditor): string {
    switch (editor) {
        case 'captions':
            return 'Captions'
        case 'crop':
            return 'Crop'
        case 'default':
            return 'Edit'
        case 'filters':
            return 'Filters'
        case 'layers':
            return 'Layers'
        case 'stickers':
            return 'Stickers'
    }
}

export default UgeEditor
